import { render, staticRenderFns } from "./PolygonDrawer.vue?vue&type=template&id=271f78d5&scoped=true&"
import script from "./PolygonDrawer.vue?vue&type=script&lang=ts&"
export * from "./PolygonDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./polygon-drawer.scss?vue&type=style&index=0&id=271f78d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f78d5",
  null
  
)

export default component.exports